import React, { useState } from "react";
import style from "./LoginForm.module.css";
import LoginScreen from "./assets/loginscreen.png";
import logo from "./assets/logo.png";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { API_BASE_URL } from "./config.js";

const LoginForm = () => {
  const [VendorCode, setVendorCode] = useState("");
  const [Password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState("");
  const navigate = useNavigate();
  const [showTerms, setShowTerms] = useState(false);
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    try {
      const response = await fetch(`${API_BASE_URL}/Login`, {
        method: "Post",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          UserId: VendorCode,
          Password: Password,
        }),
      });
      const data = await response.json();
      if (response.ok) {
        sessionStorage.setItem("vendordata", JSON.stringify(data[0]));
        navigate("/dashboard");

        toast.success("Login successful!");
      } else {
        toast.error(data[0].Message || "Login failed");
      }
    } catch (err) {
      setError("Something went wrong");
    }
    setLoading(false);
  };
  return (
    <div className={style.LoginForm}>
      <div className={style.LoginFormContainer}>
        <div className={style.ImgSection}></div>
        <div className={style.LoginFormSection}>
          <form className={style.LoginContainer} onSubmit={handleSubmit}>
            <div className={style.organizationlogo}>
              <img src={logo} alt="Login visual" />
            </div>
            <div className={style.formgroup}>
              <label>User Id</label>
              <input
                type="text"
                placeholder="Enter User Id Here"
                value={VendorCode}
                onChange={(e) => setVendorCode(e.target.value)}
                required
              />
            </div>
            <div className={style.formgroup}>
              <label>Password</label>
              <input
                type="password"
                placeholder="Enter Password Here"
                value={Password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </div>
            <div className={style.termservice}>
              *By continuing to use this website, I have read, understood, and
              agree to be bound by the{" "}
              <span
                style={{
                  color: "#007bff",
                  cursor: "pointer",
                  textDecoration: "underline",
                }}
                onClick={() => setShowTerms(true)}
              >
                Vendor EDI Portal Disclaimer & Terms of Use
              </span>{" "}
              in their entirety.
            </div>
            <button className={style.loginbtn} type="submit">
              {loading ? "Logging in..." : "Login"}
            </button>
            {error && (
              <div
                style={{ color: "red", marginBottom: "5px", fontSize: "10px" }}
              >
                {error}
              </div>
            )}
          </form>
        </div>
      </div>

      {showTerms && (
        <div className={style.modalOverlay}>
          <div className={style.modalContent}>
            <div className={style.modalHeader}>
              <h3>Vendor EDI Portal Disclaimer & Terms of Use</h3>
            </div>

            <div className={style.modalBody}>
              <div class="terms-container">
                <h3>1. Introduction & Acceptance of Terms</h3>
                <p>
                  This Vendor EDI Portal ("Portal") is developed, owned, and
                  operated by iWorkkz and is made available to authorised
                  vendors ("Vendors," "You," "Your") of iWorkkz's customers
                  ("Customers") for the sole purpose of facilitating Electronic
                  Data Interchange ("EDI") transactions, document exchange, and
                  related business communications between Vendors and the
                  relevant Customer.
                </p>
                <p>
                  By accessing, registering on, or using this Portal in any
                  manner, You acknowledge that You have read, understood, and
                  agree to be bound by this Disclaimer and the accompanying
                  Terms of Use in their entirety. If You do not agree to these
                  terms, You must immediately discontinue use of the Portal and
                  notify the relevant Customer or iWorkkz of Your decision.
                </p>

                <h3>2. Purpose & Scope of the Portal</h3>
                <ul>
                  <li>
                    Submission, receipt, and processing of purchase orders,
                    invoices, advance shipping notices, goods receipt notes, and
                    other EDI-standard business documents.
                  </li>
                  <li>
                    Real-time or near-real-time visibility into order and
                    transaction statuses.
                  </li>
                  <li>
                    Upload and management of Vendor master data, catalogues,
                    pricing information, and compliance documentation as
                    required by the Customer.
                  </li>
                  <li>
                    Communication and collaboration between Vendors and the
                    Customer's procurement, logistics, and finance teams.
                  </li>
                </ul>
                <p>
                  The specific features may vary based on Customer
                  configuration. iWorkkz reserves the right to modify features
                  at any time.
                </p>

                <h3>3. Relationship of Parties</h3>
                <p>
                  iWorkkz acts solely as a technology service provider and is
                  not a party to Vendor-Customer transactions.
                </p>
                <p>
                  All business commitments are strictly between Vendor and
                  Customer.
                </p>
                <p>
                  iWorkkz does not verify or guarantee any party’s credibility.
                </p>

                <h3>4. Access & Authorisation</h3>
                <p>
                  Access is restricted to authorised Vendors. Credentials must
                  not be shared.
                </p>
                <p>
                  You are responsible for all activities under your account.
                </p>
                <p>Access may be revoked at any time without notice.</p>

                <h3>5. Data Accuracy, Integrity & Responsibility</h3>
                <p>All Vendor Data is submitted at your own risk.</p>
                <p>
                  You are responsible for accuracy and compliance of all
                  submitted data.
                </p>
                <p>
                  iWorkkz is not liable for any issues arising from incorrect
                  data.
                </p>

                <h3>6. Data Privacy & Confidentiality</h3>
                <p>Data handling is governed by the Privacy Policy.</p>
                <p>All portal data is confidential and must not be misused.</p>
                <p>Vendors must comply with applicable data protection laws.</p>

                <h3>7. Intellectual Property</h3>
                <p>All platform rights belong to iWorkkz.</p>
                <p>No reverse engineering or copying is allowed.</p>

                <h3>8. Limitation of Liability</h3>
                <p>
                  <strong>
                    THE PORTAL IS PROVIDED "AS IS" WITHOUT WARRANTIES.
                  </strong>
                </p>
                <p>
                  iWorkkz is not liable for indirect or consequential damages.
                </p>

                <h3>9. System Availability & Maintenance</h3>
                <p>
                  Portal availability is not guaranteed and may include
                  downtime.
                </p>

                <h3>10. Acceptable Use Policy</h3>
                <ul>
                  <li>Use only for intended business purposes</li>
                  <li>No unlawful or harmful content</li>
                  <li>No unauthorized access attempts</li>
                  <li>No malware or automated misuse</li>
                </ul>

                <h3>11. Indemnification</h3>
                <p>
                  Vendors agree to indemnify iWorkkz against claims arising from
                  misuse or violations.
                </p>

                <h3>12. Third-Party Services</h3>
                <p>
                  iWorkkz is not responsible for third-party services or
                  integrations.
                </p>

                <h3>13. Modifications to Terms</h3>
                <p>
                  Terms may be updated at any time. Continued use implies
                  acceptance.
                </p>

                <h3>14. Governing Law & Dispute Resolution</h3>
                <p>Governed by applicable jurisdiction laws.</p>

                <h3>15. Severability</h3>
                <p>If any provision is invalid, others remain effective.</p>

                <h3>16. Waiver</h3>
                <p>Failure to enforce any right does not waive it.</p>

                <h3>17. Entire Agreement</h3>
                <p>This constitutes the complete agreement.</p>

                <h3>18. Contact Information</h3>
                <p>Email: care@iworkkz.com</p>
              </div>
            </div>

            <div className={style.modalFooter}>
              <button
                className={style.closeBtn}
                onClick={() => setShowTerms(false)}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default LoginForm;
